import { useEffect, useState } from 'react';
import '../footer/index.scss';
import { store } from '../../../application/store';
import envConfig from '../../../application/configurations/envConfig';
import { checkIntranetContext, getHeaderFooterConfig, UtilityService } from '../../../infrastructure/services/utils';

/**
 * Component for showing application footer.
 *
 * @component
 */
const Footer = () => {
  const [html, setHtml] = useState('')
  const [searchType, setSearchType] = useState<any>(null)
  const [referrer, setReferrer] = useState<any>(null)
  const userInfo = store.getState().general

  useEffect(() => {
    // Get redirection page name from 'c' query param
    const searchParams = checkIntranetContext()
    setSearchType(searchParams);

    // Get previous URL
    const previousUrl = document.referrer
    //get the url in this format 'intranet.ey.com' by removing https:// and / from the url
    const url = previousUrl.replace('https://', '').replace('/', '');
    setReferrer(url);

  }, [searchType, referrer])


  useEffect(() => {
    if (userInfo.token) {
      let userEmailIdPath = '';
      if (userInfo.account.username) {
        let encodedEmail = encodeURIComponent(
          btoa(userInfo.account.username)
        );
        userEmailIdPath = '.' + encodedEmail + '.html';
      }
      const footerUrl = getHeaderFooterConfig('footer');
      if (!footerUrl) return;
      fetch(
        footerUrl + userEmailIdPath,
        {
          credentials: 'include',
          headers: {
            'Authorization': 'Bearer ' + userInfo.token
          }
        })
        .then(async function (payload) {
          if (payload.status === 200) {
            let res = await payload.text();
            if (res !== '') {
              const parser = new DOMParser();
              const doc = parser.parseFromString(res, 'text/html');
              const spanElements = Array.from(doc.querySelectorAll('span'));

              let dataPrivacySpan = null;
              for (const spanElement of spanElements) {
                if (spanElement.textContent && spanElement.textContent.trim() === envConfig.dataPrivacy.label) {
                  dataPrivacySpan = spanElement;
                  break;
                }
              }

              if (dataPrivacySpan && dataPrivacySpan.parentNode instanceof HTMLAnchorElement) {
                const parentAnchor = dataPrivacySpan.parentNode;
                parentAnchor.href = envConfig.dataPrivacy.url; // Replace with the desired URL
                parentAnchor.removeAttribute('onclick');
              }

              const modifiedHtml = doc.documentElement.outerHTML;
              await UtilityService.cssLoad(modifiedHtml);
              setHtml(modifiedHtml);
              UtilityService.scriptLoad(modifiedHtml);
            }
          }
        })
    }
  }, [userInfo.token])

  return (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );
}

export { Footer };
